import { Component } from '@angular/core';
import { MatTabsModule } from '@angular/material/tabs';
import { TaxonomyPlaygroundComponent } from '../taxonomy-playground/taxonomy-playground.component';
import { CommonModule } from '@angular/common';
import { TaxonomyEntityHubV2Component } from '../taxonomy-entity-hub-v2/taxonomy-entity-hub-v2.component';
import { TaxonomySettingsComponent } from '../taxonomy-settings/taxonomy-settings.component';

@Component({
  selector: 'taxonomy-page',
  standalone: true,
  imports: [
    MatTabsModule,
    TaxonomyPlaygroundComponent,
    CommonModule,
    TaxonomyEntityHubV2Component,
    TaxonomySettingsComponent,
  ],
  templateUrl: './taxonomy-page.component.html',
  styleUrl: './taxonomy-page.component.scss',
})
export class TaxonomyPageComponent {
  // Entities tab always selected (index 0)
  selectedTabIndex = 0;

  // Tab change functionality commented out - entities tab always selected
  // onTabChange(index: number): void {
  //   this.selectedTabIndex = index;
  // }
}
